export const InputFieldStyles = {
  label: 'text-16px tracking-wide font-light text-goEasyGray900',
  container: (fullWidth: boolean = false) =>
    `w-full focus:border-blue400 focus:border-2 sm:mb-6 ${
      !fullWidth ? 'sm:w-328' : ''
    }`
}
